import { render } from "./g-login-register.vue?vue&type=template&id=0a156219&ts=true"
import script from "./g-login-register.vue?vue&type=script&lang=tsx"
export * from "./g-login-register.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__